import { Box, Grid, Stack, Typography } from "@mui/material";
import { selectSelectedSchool } from "app/modules/schools/selectors";
import dayjs from "dayjs";
import React from "react";
import { useSelector } from "react-redux";

const label12Sx = {
  fontWeight: 500,
  fontSize: "12px",
};

const value12Sx = {
  fontWeight: 600,
  fontSize: "12px",
};

const centerValueSx = {
  ...value12Sx,
  textAlign: "center",
};

const SchoolPrintHeader = () => {
  const selectedSchool = useSelector(selectSelectedSchool);

  return (
    <Box>
      <Box>
        <Grid container columnSpacing={1.5} rowSpacing={1} alignItems="center">
          <Grid item xs={12} sm="auto">
            <Box
              sx={{
                height: { xs: 84, sm: 92 },
                width: { xs: 84, sm: 92 },
                p: 0.5,
                borderRadius: 2,
                border: "1px solid",
                borderColor: "divider",
                bgcolor: "grey.100",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                component="img"
                src={selectedSchool?.schoolLogo}
                alt="school-logo"
                sx={{
                  height: "100%",
                  width: "100%",
                  objectFit: "contain",
                  borderRadius: 2,
                }}
              />
            </Box>
          </Grid>

          <Grid item xs>
            <Stack spacing={0.75}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "18px",
                    textAlign: "center",
                  }}
                >
                  {selectedSchool?.schoolName}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                >
                  {selectedSchool?.schoolAddress?.address}
                  <br />
                  {selectedSchool?.schoolAddress?.dist},{" "}
                  {selectedSchool?.schoolAddress?.state},{" "}
                  {selectedSchool?.schoolAddress?.pinCode}
                </Typography>
              </Box>

              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs={12} sm={8}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "12px",
                    }}
                  >
                    Affiliated With : {selectedSchool?.affiliatedTo}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "12px",
                    }}
                  >
                    UDISE Code: {selectedSchool?.udiseCode ?? "--"}
                  </Typography>
                </Grid>
              </Grid>
            </Stack>
          </Grid>
        </Grid>
      </Box>

      <Stack direction="row" alignItems="center" sx={{ pt: 0.7 }}>
        <Typography
          sx={{
            ...label12Sx,
            flex: 1,
          }}
        >
          School No :{" "}
          <Box component="span" sx={value12Sx}>
            {selectedSchool?.schoolRegisterNumber}
          </Box>
        </Typography>
        <Typography
          sx={{
            ...label12Sx,
            flex: 1,
            textAlign: "center",
          }}
        >
          Affiliation Number :{" "}
          <Box component="span" sx={value12Sx}>
            {selectedSchool?.affiliationNumber}
          </Box>
        </Typography>
        <Typography
          sx={{
            ...label12Sx,
            flex: 1,
            textAlign: "end",
          }}
        >
          Affiliation Up To :{" "}
          <Box component="span" sx={value12Sx}>
            {selectedSchool?.affiliationUpTo
              ? dayjs(selectedSchool?.affiliationUpTo).format("YYYY")
              : "...................."}
          </Box>
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography
          sx={{
            ...label12Sx,
            flex: 1,
          }}
        >
          Website :{" "}
          <Box component="span" sx={value12Sx}>
            {selectedSchool?.website}
          </Box>
        </Typography>
        <Typography
          sx={{
            ...centerValueSx,
            flex: 1,
          }}
        >
          Contact No :{" "}
          <Box component="span" sx={value12Sx}>
            {selectedSchool?.schoolContactNumber}
          </Box>
        </Typography>
        <Typography
          sx={{
            ...value12Sx,
            flex: 1,
            textAlign: "end",
          }}
        >
          Email :{" "}
          <Box component="span" sx={value12Sx}>
            {selectedSchool?.email}
          </Box>
        </Typography>
      </Stack>
    </Box>
  );
};

export default SchoolPrintHeader;
